<template>
  <v-icon
    size="medium"
    :color="getStockStatusColor(stockStatus)"
    :icon="mdiCircle"
    :aria-label="$t('stockStatusDescription', [$t('stockStatus.' + stockStatus)])"
  />
</template>

<script setup lang="ts">
import { getStockStatusColor } from '@/modules/product/helpers'
import { Availability } from '@/types/index'
import { mdiCircle } from '@mdi/js'
import { PropType } from 'vue'

defineProps({
  stockStatus: {
    type: String as PropType<Availability>,
    default: undefined
  }
})
</script>
